import { Button, ButtonProps, SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles({
  actionButton: {
    width: '35px',
    height: '35px',
    borderRadius: '4px',
    borderWidth: '2px',

    '&:hover': {
      borderWidth: '2px',
    },
  },
});

type ActionButtonProps<C extends React.ElementType> = ButtonProps<C, { component?: C }> & {
  icon: React.ElementType;
};

const ActionButton = <C extends React.ElementType>({ className, icon, ...props }: ActionButtonProps<C>) => {
  const classes = useStyles();

  return (
    <Button {...props} className={classNames(className, classes.actionButton)} color="primary">
      <SvgIcon component={icon} />
    </Button>
  );
};

export default ActionButton;
